class Constants {
  [index: string]: any

  constructor(record = {} as Record<string, any>) {
    for (let key in record) {
      this[key] = record[key]
    }
  }

  get(value: string) {
    return this[value]
  }

  set(key: string, value: any) {
    this[key] = value
  }
}

const constants = new Constants()

export default constants
